import { BasicService } from "./core/basic.service";
import moment from 'moment';

export class UserService extends BasicService {

  static getList(data) {
    return this.http.post('/users/getList',data);
  }

  static detail(user_id) {
    return this.http.get('/users/detail', { user_id });
  }

  static receiveAddress(user_id) {
    return this.http.post('/users/userAddress', { user_id });
  }

  static giveIntegral(data) {
    return this.http.post('/users/presentsPoints', data);
  }
  // 拒绝审核
  static rejectAudit(user_id, reject_reason) {
    return this.http.post('/users/userReject', { user_id, reject_reason });
  }

  // 接受申请
  static applyAudit(user_id) {
    return this.http.post('/users/userApply', { user_id });
  }

  // 同意审核
  // 获取企业信息
  static getCompanyInfo(user_id) {
    return this.http.post('/users/userCertificates', { user_id });
  }

  // 企业资料保存
  static saveCompany(data) {
    delete data.reject_reason;
    return this.http.post('/users/userCertificatesSave', data);
  }
  // 单个用户积分表
  static integralList(user_id, page, page_size) {
    return this.http.post('/users/accountList', { user_id, page, page_size });
  }

  static getIntegralList(data) {
    return this.http.post('/users/userAccountLog', data);
  }

  static async getErpEnterPrise() {
    return this.http.post('/business/getList', { page_size: 99999 });
  }

  static async save(data) {
    const reqData = Object.assign({}, data);
    if(reqData.birthday) {
      reqData.birthday = moment(reqData.birthday).format('YYYY-MM-DD');
    }
    await this.extractImg(reqData, 'head_pic');
    return this.http.post('/users/userSave', reqData);
  }
}